<template>
  <div>
    <div class="menupanel" v-if="menupanel" :style="menuStyle">

      <el-tabs v-model="activeName">
        <el-tab-pane label=" Services" name="first">
          <el-tree
            :data="this.$store.state.ServiceTree"
            show-checkbox
            default-expand-all
            ref="treeServ"
            node-key="id"
            :default-checked-keys="this.services"
            :props="defaultProps">
          </el-tree>
        </el-tab-pane>
        <el-tab-pane label="Customer Segments" name="second">
          <el-tree
            :data="this.$store.state.CustomerSegmentsTree"
            show-checkbox
            default-expand-all
            ref="treeServ"
            node-key="id"
            :default-checked-keys="this.services"
            :props="defaultProps">
          </el-tree>

        </el-tab-pane>

      </el-tabs>

    </div>

    <VueDragResize
      :isActive="this.blocks.active"
      @activated="onActivated"
      @deactivated="onDeactivated"
      @clicked="onClicked"
      :preventActiveBehavior="this.$store.state.preventActiveBehavior"
      :parentLimitation="false"
      :w="dateToCoords.w"
      :h="this.heightcomp"
      :minh="10"
      :x="dateToCoords.x-parentx"
      :y="(this.blocks.y+this.yoffset)*this.$store.state.rowHeight"
      axis="x"

      :isResizable="this.blocks.active"
      :isDraggable="this.blocks.active"

      :sticks="['ml','mr']"
      :snapToGrid="true"
      :gridX="this.$store.state.colWidth"
      :gridY="this.$store.state.rowHeight"
      @dragstop="dragandresize"
      @resizestop="dragandresize"

      :z="this.idlevel+this.zoffset"
      :style="{'background-color': typeColor(),
                'outline': typeBorder(),
                'color': '#fff',
                'border-radius': '5px',
                'padding-left':'0',
                'padding-top': '0',
                'padding-bottom': '0',
                'padding-right': '0',
                'margin': '0px auto',
                'border': '1px solid rgba(0,0,0,.125)'
                }"
      >
      <div class="blocktext">
        <area-chart
        v-if="this.$store.state.showCharts"
        :width="(this.dateToCoords.w)"
        :height='5*this.$store.state.rowHeight+"px"'
        :library="chartOptions"
        :legend= false
         :data="[
          {name: 'High', data: this.chartData[1], dataset: {fill: 0},legend: false},
          {name: 'Low', data: this.chartData[2], dataset: {fill: 0},legend: false},
          {name: 'Medium', data: this.chartData[0], dataset: {fill: 3},legend: false}
          ]"
          :points="false" :colors="['#ffffffa1', '#ffffffa1','#003950']"
          >
        </area-chart>

      </div>

      <div class="blocktextsub">
        <div class="containersb">
          <div class="flex-itemsb2">
            <div class="containersb">
              <div class="flex-itemsb">
                <el-button type="info" plain size="mini" icon="el-icon-set-up" circle @click="menupanel = !menupanel"  circle  v-if="this.idlevel==2"></el-button>

              </div>
              <div class="flex-itemsb">
                <el-button  size="mini" icon="el-icon-s-unfold" circle @click="expandSubBlock()" circle></el-button>

              </div>
              <div class="flex-itemsb">
                <el-button  icon="el-icon-plus" circle @click="AddChildDialogVisible = true" size="mini"></el-button>

              </div>
              <div class="flex-itemsb" v-if="this.idlevel==1">
                <el-button  icon="el-icon-connection" circle type="danger" size="mini" v-if="this.corecheck" @click="toggleCoreLink()"></el-button>
                <el-button  icon="el-icon-connection" circle type="warning" size="mini" v-if="!this.corecheck" @click="toggleCoreLink()"></el-button>

              </div>
            </div>
          </div>
          <div v-if="this.idlevel>2" class="TitleBlockBase">
              {{this.blocks.name}}--y {{this.blocks.y}} --h {{this.blocks.h}} --z {{this.idlevel}} - Status {{this.blocks.status}}- Active {{this.blocks.active}}

              <!-- <CanvasInlineTitle :textin="this.blocks.name"></CanvasInlineTitle> -->
          </div>
          <div v-if="this.idlevel==1" class="TitleBlockAlt">
              {{this.blocks.name}}--y {{this.blocks.y}} --h {{this.blocks.h}} --z {{this.idlevel}} - Status {{this.blocks.status}}- Active {{this.blocks.active}}

              <!-- <CanvasInlineTitle :textin="this.blocks.name"></CanvasInlineTitle> -->
          </div>
          <div v-if="this.idlevel==2" class="TitleBlockAlt2">
              {{this.blocks.name}}--y {{this.blocks.y}} --h {{this.blocks.h}}--z {{this.idlevel}} - Status {{this.blocks.status}}- Active {{this.blocks.active}}
              <!-- <CanvasInlineTitle :textin="this.blocks.name"></CanvasInlineTitle> -->
          </div>

        </div>

      </div>

    </VueDragResize>

    <el-dialog
      title="Add Child"
      :visible.sync="AddChildDialogVisible"
      width="30%"
      :modal=false
      :before-close="handleClose">

        <el-form :model="form">
          <el-form-item label="Child Name" :label-width="formLabelWidth">
            <el-input v-model="form.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="Type" :label-width="formLabelWidth">
            <el-cascader
              placeholder=""
              v-model="form.type"
              :options="this.addChildOptions"
              :props="{ expandTrigger: 'hover' }"
              @change="handleNewChildChange"
              >

              <template slot-scope="{ node, data }">
                <span>{{ data.label }}</span>
                <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
              </template>

            </el-cascader>
          </el-form-item>

        </el-form>


      <span slot="footer" class="dialog-footer">
        <el-button @click="AddChildDialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="handleAddChildClose()">Add Child</el-button>
      </span>
    </el-dialog>

  </div>


</template>

<style>

.blocktext {
    position: absolute;
    z-index: 40;
    width: 100%;
    height:auto;
}
.blocktextsub {
    position: relative;
    z-index: 40;
}

.el-dropdown {
  vertical-align: top;
}
.el-dropdown + .el-dropdown {
  margin-left: 15px;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.sideTabStyle {
  position: absolute;
  /* left: -200px;
  width: 200px;
  height: 500px; */
  /* height: 1000px; */
  top: var(--sideTab-top);
  /* right: var(--menu-right); */
  left: var(--sideTab-left);
  width: var(--sideTab-width);
  z-index: 1000;
  /* z-index: var(--menu-z); */
  height: var(--sideTab-height);
  background-color:#8edfff40;
  color: #003950;

  border: 0px 10px 10px 0px solid #003950;
  border-radius: 5px;
}
.menupanel {
  position: absolute;
  /* left: -200px;
  width: 200px;
  height: 500px; */
  /* height: 1000px; */
  top: var(--menu-top);
  /* right: var(--menu-right); */
  left: var(--menu-left);
  width: var(--menu-width);
  z-index: 1000;
  /* z-index: var(--menu-z); */
  /* height: var(--menu-height); */
  background-color:#ffffff;
  color: #003950;
  padding-left: 2px;
  border: 1px solid rgba(0,0,0,.125);
  border-radius: 5px;
}

.el-cascader-node__label {
    flex: 1;
    padding: 0 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-family: Avenir, Helvetica, Arial, sans-serif;
}

.containersb{
    width:100%;
    display: flex;

    text-align: left;

}
.fixedsb{
  text-align: left;
  font-size: larger;
}
.fixedsb2{
  width:300px;
  text-align: left;
  font-weight: 700;

}
.TitleBlockBase{
  /* width:300px; */
  text-align: left;
  font-weight: 700;
  color: #ffffff;

}

.TitleBlockAlt{
  /* width:400px; */
  text-align: left;
  font-weight: 900;
  font-size: larger;
  color: #003950;

}

.TitleBlockAlt2{
  /* width:400px; */
  text-align: left;
  font-weight: 800;
  font-size: larger;
  color: #ffffff;

}

.TitleBlockAlt3{
  /* width:400px; */
  text-align: left;
  font-weight: 700;
  font-size: larger;
  color: #003950;

}
.flex-itemsb{

    width: 50px;


}
.flex-itemsbgroup{

    width: 450px;


}
[class*=" el-icon-"], [class^=el-icon-] {
    font-family: element-icons!important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    font-size: larger;
    text-transform: none;
    line-height: 1;
    vertical-align: baseline;
    display: inline-block;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

.flex-itemCascader{
    width: 100px;
    font-weight: 700;
    /* background-color: #003950; */

}
.flex-itemsb2{
  width: 250px;
}
.CanvasBlockSubContainer {
  position: absolute;
  left: 0px;
  top: var(--group-top);
  width: var(--group-width);
  height: var(--group-height);
  background-color: var(--type-bg-color);
  color: #ffffff;

  border: 1px solid #003950;
  border-radius: 5px;
}
.SubBlockTitle {
  /* position: relative;
  border: 1px solid #ffffff;
  background-color: #003950; */
  color: #fff;
  /* border-radius: 0px; */
  padding: 0px;
  font-weight: 700;


}

</style>
<script>


export default {
  name: 'CanvasOmniBlock',
  components: {

    //CanvasInlineTitle//, VueDragResize
  },
  props: {
    yoffset: {
      default: 0
    },
    zoffset: {
      default: 110
    },
    headerOnly: {
      default: false
    },
    idin: {

    },
    scenarioset: {

    },
    // services: {
    //   //default:[1]
    // },
    custSegs: {
      //default:[1]
    },
    products: {
      //default:[1]
    },

    index: {
      default: 1
    },

    blocks: {

    },
    type: {
      default: 1
    },
    typecolor: {

    },
    greatgrandparentid: {

    },
    grandparentid: {

    },
    parentid: {

    },
    id: {

    },
    daterange: {

    },

    timelinezoomlevel: {

    },
    parenttype: {
      default: 0
    },
    parentxdate: {

    },
    parentx: {
      default: 0
    },
    parenty: {
      default: 0
    },
    parentxupdate: {
      //default: false
    },
    grandparentx: {

    },
    grandparentxupdate: {
      //default: false
    }

  },
  data: function () {
    return {
      form: {
        name: '',
        type:[],
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      },
      formLabelWidth: '120px',
      groupHeightExpand: false,
      SubBlockLayerSelected:false,
      AddChildDialogVisible:false,
      preventActiveBehavior:false,
      Draggable:true,
      Resizeable:true,
      menupanel: false,
      active: false,
      width2: 500,
      height: 30,
      height2: 300,
      services:[121],
      activeName:"first",

      defaultProps: {
        children: 'children',
        label: 'label'
      },
      top2: 0,
      left2: 0,
      addChildvaluevalue: "Add Child",
      chartOptions: {
        layout: {
          padding: {left: 1, right: 1, top: 5, bottom: 2}
        },
        scales: {
          yAxes: [{
            display: false // this hides the x-axis
          }],
          xAxes: [{
            display: false // this hides the x-axis
          }]
        }
      }
    }
  },
  // watch: {
  //   blocks: function() {
  //
  //     console.log("watch detected blocks update",this.blocks)
  //     this.height=this.blocks.h*this.$store.state.rowHeight
  //
  //     console.log(this.height)
  //   }
  //
  // },
  methods: {
    handleNewChildChange(value) {
      console.log("new child selected from cascader",value);

    },
    handleClose(done) {
      this.$confirm('Are you sure to close this dialog?')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleAddChildClose() {
      console.log("new child selected from cascader",this.form.type);
      this.AddChildDialogVisible =false

      this.$store.dispatch('AddChildBlock',[this.blocks.id,this.form])

    },
    onActivated() {
      //this.active=true;

      //deactivate all other VueDragResize
      //this.$store.dispatch('DeactivateAllOtherVDRInstances',this.blocks.id)

    },
    onDeactivated() {

      //this.$store.dispatch('DeactivateAllOtherVDRInstances',0)

    },
    onClicked() {
      console.log("onClicked",this.blocks.id)

    },
    dragandresize(newRect) {
      console.log(this.blocks.name,"resize run","active:",this.active)
      console.log("old x:",this.dateToCoords.x,"new x:",newRect.left+this.parentx)


      if(this.timelinezoomlevel=="days"){
        var dateIndex = JSON.parse(JSON.stringify(this.$store.state.DateIndex));

      }else{
        var dateIndex = JSON.parse(JSON.stringify(this.$store.state.MonthIndex));

      }

      var newDate = new Date(dateIndex[(newRect.left+JSON.parse(JSON.stringify(this.parentx)))/this.$store.state.colWidth])
      var newDate2 = new Date(dateIndex[(newRect.left+newRect.width)/this.$store.state.colWidth])

      if((this.dateToCoords.x==newRect.left+this.parentx)&&(this.dateToCoords.w==newRect.width)){
        console.log("no change so no update")
      }else{
        console.log("change so update","old x:",this.dateToCoords.x,"new x:",newRect.left+this.parentx,"new date",newDate)
        console.log("new date",[{year:newDate.getFullYear(),month:newDate.getMonth()+1,day:newDate.getDate()}][0])
        this.$store.dispatch('UpdateOmniBlockDimensions',[this.blocks.id,this.timelinezoomlevel,
          (newRect.left+this.parentx)/this.$store.state.colWidth,
          newRect.width/this.$store.state.colWidth,
          newRect.top/this.$store.state.rowHeight,
          newRect.height/this.$store.state.rowHeight,
          [{year:newDate.getFullYear(),month:newDate.getMonth()+1,day:newDate.getDate()}][0],
          [{year:newDate2.getFullYear(),month:newDate2.getMonth()+1,day:newDate2.getDate()}][0]

        ])

      }


      // this.left2 = newRect.left;
    },
    clickBlock: function(){
      console.log("you clicked me",this.blocks)

      //this.$store.dispatch('SetActiveCanvasBlock',this.blocks.id)

    },
    deselectBlock: function(){
      console.log("you deselected me",this.blocks)
      //this.$store.dispatch('SetActiveCanvasBlock',0)

    },
    expandSubBlock: function(){
      console.log("ExpandOmniBlock",this.blocks.id,this.blocks.status)
      // this.Resizeable=false
      // this.Draggable=false
      this.$store.dispatch('VDRpreventActiveBehavior',1)

      this.$store.dispatch('ExpandOmniBlock',[this.blocks.id,this.blocks.status])
      // this.Resizeable=true
      // this.Draggable=true
    },
    addChild: function(){
      console.log("AddChild",this.blocks.id)
      this.$store.dispatch('AddChildBlock',this.blocks.id)
    },
    typeBorder() {
      //console.log("this.idlevel",this.idlevel)

      if(this.blocks.combination==true){

        return '10px 10px 10px 10px solid '+this.typeColor();

      }else{

        if(this.idlevel==1){

          return '10px 10px 10px 10px solid '+this.typeColor();

        }else if(this.idlevel==2){

          return '0px';

        }else if(this.idlevel==3){
          return '0px';

        }else if(this.idlevel==4){
            return '0px';
        }else{
          return 'pink';
        }

      }


    },
    typeColor() {
      //console.log("typeColor this.idlevel",this.idlevel,this.blocks.type)
      if(this.blocks.combination==true){
        return '#72bf44';
      }else{
        if(this.idlevel==1){

          return '#8edfff40';

        }else if(this.idlevel==2){

          return '#7fbad28a';

        }else if(this.idlevel==3){

          var type = this.blocks.type

          if(type==1){
            return '#003950';

          }else if (type==2) {
            return '#72bf44';

          }else if (type==3) {
            return '#57c7da';

          }else if (type==4) {
            return '#e6ce3c';

          }else if (type==5) {
            return '#C70039';

          }else{
            return 'black';
          }
        }else if(this.idlevel==4){
            return '#ffffff55';
        }else{
          return 'pink';
        }
      }


    },

    Blocktype(type) {
      if(type==1){
        return 'Trend';

      }else if (type==2) {
        return 'Event';

      }else if (type==3) {
        return 'External Factors';

      }else if (type==4) {
        return 'Seasonal';

      }else if (type==5) {
        return 'Cycle';

      }else{
        return 'Other';
      }

    },
    findDateIndex(DateIndex,DateToFind) {

      var index = DateIndex.findIndex((v) => {
        return new Date(v).getTime()===new Date(DateToFind).getTime();
      });

        return index;
    },
    toggleCoreLink() {
      console.log("toggleCoreLink")


      if(JSON.stringify(this.blocks.id)==JSON.stringify(this.blocks.coreid)){
        console.log("remove corelink",this.scenarioset)

        //make clone
        this.$store.dispatch('UpdateCanvasGroupCoreLinks',[this.blocks.id,true])

      }else{
        console.log("establish corelink")
        this.$store.dispatch('UpdateCanvasGroupCoreLinks',[this.blocks.id,false])

      }
    }

  },

  computed: {
    corecheck() {
      //console.log("In corecheck",this.blocks.id,this.blocks.coreid)
      if(JSON.stringify(this.blocks.id)==JSON.stringify(this.blocks.coreid)){
        //console.log("corecheck true")
        return true
      }else{
        return false
      }

    },
    heightcomp() {

      if(this.headerOnly){

        return (5)*this.$store.state.rowHeight

      }else{

        return this.blocks.h*this.$store.state.rowHeight

      }

    },
    chartData() {
      //console.log("chartData")
      var daterange = this.blocks.daterange
      var startDate =new Date(daterange[0].year,(daterange[0].month-1),daterange[0].day)
      var endDate =new Date(daterange[1].year,(daterange[1].month-1),daterange[1].day)

      var clone = JSON.parse(JSON.stringify(this.$store.state.DateIndex));
      var clone1 = JSON.parse(JSON.stringify(this.$store.state.MonthIndex));

      if(this.timelinezoomlevel=="days"){
        var dateIndex = JSON.parse(JSON.stringify(this.$store.state.DateIndex));

      }else{
        var dateIndex = JSON.parse(JSON.stringify(this.$store.state.MonthIndex));

      }

      var startIndex = dateIndex.findIndex((v) => {
        return new Date(v).getTime()===new Date(startDate).getTime();
      });

      var endIndex = dateIndex.findIndex((v) => {
        return new Date(v).getTime()===new Date(endDate).getTime();
      });
      console.log("startIndex",startIndex,"endIndex",endIndex)
      var dateIndexSub = dateIndex.slice(startIndex,endIndex+1)
      var newChartData = []
      var newChartDataH = []
      var newChartDataL = []

      // for(let d=0; d<dateIndexSub.length; d++){
      //   newChartData.push([dateIndexSub[d],d])
      //   newChartDataH.push([dateIndexSub[d],d+(1.1^d)])
      //   newChartDataL.push([dateIndexSub[d],d-(1.1^d)])
      //
      // }


      for(let d=0; d<this.blocks.output.time.length; d++){
        console.log("d",d)
        let xDate=new Date(this.blocks.output.time[d])
        if(xDate instanceof Date && !isNaN(xDate)){
          //console.log("x is a Date",xDate)
          var startDate =xDate

        }else{
          //console.log("x is not a Date",x)
          var startDate =new Date(this.blocks.output.time[d].year,(this.blocks.output.time[d].month),this.blocks.output.time[d].day)

        }
        console.log("startDate",startDate,this.blocks.output.time[d])

        newChartData.push([startDate,this.blocks.output.value[d]])
        newChartDataH.push([startDate,this.blocks.output.value[d]+(1.1^d)])
        newChartDataL.push([startDate,this.blocks.output.value[d]-(1.1^d)])

      }

      console.log("newChartData".newChartData)
      return[newChartData,newChartDataH,newChartDataL]


    },
    sideTab () {

      var gwidth = 30

      return {
      '--sideTab-top': `${this.blocks.y*this.$store.state.rowHeight}px`,

      '--sideTab-left': `${this.dateToCoords.x-gwidth}px`,
      '--sideTab-right': `${this.dateToCoords.x}px`,

      '--sideTab-width': `${gwidth}px`,
      '--sideTab-height':`${this.blocks.h*this.$store.state.rowHeight}px`,
      '--sideTab-z': `${this.blocks.id.length}`

      }
    },

    menuStyle () {
      var gwidth = 300
      return {
      '--menu-top': `${this.blocks.y*this.$store.state.rowHeight}px`,

      '--menu-left': `${this.dateToCoords.x-gwidth}px`,
      '--menu-right': `${this.dateToCoords.x}px`,

      '--menu-width': `${gwidth}px`,
      '--menu-height':`${this.blocks.h*this.$store.state.rowHeight}px`,
      '--menu-z': `${this.blocks.id.length}`

      }
    },
    addChildOptionsFlat (){
      if(this.idlevel==0){
        var options = ["New Group"]
      }else if(this.idlevel==1) {
        var options = ["New Assumption Block"]

      }else if(this.idlevel==2){
        var options = ["Trend","Event","Factor","Seasonal","Stochastic"]
      }else{
        //need to know parent type
            options = ["Sub-layer"]
      }
      return options

    },
    addChildOptions (){

      //console.log("addChildOptions",this.blocks)
      if(this.idlevel==0){
        var options = [{
          value: 'newgroup',
          label: 'New Group',
          children: [{
            value: 'blank',
            label: 'Blank'
          }]
        }]
      }else if(this.idlevel==1) {
        var options = [{
          value: 'newblock',
          label: 'New Block',
          children: [{
            value: 'blank',
            label: 'Blank'
          }]
        }]

      }else if(this.idlevel==2){
        var options = [{
          value: '1',
          label: 'Trend',
          children: [{
            value: '1.1',
            label: 'Linear'
          },
          {
            value: '1.2',
            label: 'Exponential'
          }
        ]
        },
        {
          value: '2',
          label: 'Event',
          children: [{
            value: '2.1',
            label: 'Single Event'
          },{
            value: '2.2',
            label: 'Recurring'
          }]
        },
        {
          value: '3',
          label: 'External Factors',
          children: [{
            value: '3.1',
            label: 'Basic'
          }]
        },
        {
          value: '4',
          label: 'Seasonal',
          children: [{
            value: '4.1',
            label: 'Annual'
          },
          {
            value: '4.2',
            label: 'Quarterly'
          },
          {
            value: '4.3',
            label: 'Monthly'
          },
          {
            value: '4.4',
            label: 'Weekly'
          },
          {
            value: '4.5',
            label: 'Irregular'
          }
        ]
        }]
      }else{
        //need to know parent type
        var options = [{
          value: '5',
          label: 'Sub Layer',
          children: [{
            value: '5.1',
            label: 'Sub Layer 1'
          }]
        }]
      }

      //console.log("addChildOptions,options",options)

      return options

    },

    idlevel (){
      //console.log("idlevel Comp", this.blocks)
      return this.blocks.id.length
    },

    dateToCoords () {
      //console.log("this.daterange",this.daterange)

      var clone = JSON.parse(JSON.stringify(this.$store.state.DateIndex));
      var clone1 = JSON.parse(JSON.stringify(this.$store.state.MonthIndex));


      //need to find nearest date
      //if day is < mid month, set day to 1 for current month, else, move to next month and set day==1
      var tdaterange = this.blocks.daterange

      if(this.timelinezoomlevel=="days"){
        //console.log("looking for DateIndex")

        var startDate =new Date(tdaterange[0].year,(tdaterange[0].month-1),tdaterange[0].day)
        var endDate =new Date(tdaterange[1].year,(tdaterange[1].month-1),tdaterange[1].day)


        //console.log("FoundIndex for Canvas-Group should follow me")
        var foundIndex = this.findDateIndex(clone,startDate)
        //console.log("startDate",startDate,"@ index", foundIndex)

        var foundIndex2 = this.findDateIndex(clone,endDate)
        //console.log("startDate",endDate,"@ index", foundIndex2)

        var x = foundIndex*this.$store.state.colWidth
        var w = (foundIndex2-foundIndex)*this.$store.state.colWidth

      }else{
        //console.log("looking for MonthIndex CSB")
        //console.log("clone1",clone1)

        if(tdaterange[0].day<15){
          var startDate =new Date(tdaterange[0].year,(tdaterange[0].month)-1,1)

        }else{
          var startDate =new Date(tdaterange[0].year,(tdaterange[0].month),1)

        }
        if(tdaterange[1].day<15){
          var endDate =new Date(tdaterange[1].year,(tdaterange[1].month-1),1)

        }else{
          var endDate =new Date(tdaterange[1].year,(tdaterange[1].month),1)

        }

        //console.log("FoundIndex for Canvas-Group should follow me")
        var foundIndex = this.findDateIndex(clone1,startDate)
        //console.log("startDate",startDate,"@ index", foundIndex)

        var foundIndex2 = this.findDateIndex(clone1,endDate)
        //console.log("startDate",endDate,"@ index", foundIndex2)

        var x = foundIndex*this.$store.state.colWidth
        var w = (foundIndex2-foundIndex)*this.$store.state.colWidth
      }

      return {x:x,w:w};


      //return this.daterange;

    },
  }

}
</script>
